import { z } from 'zod';

export const AccountTypeSchema = z.enum([
  'asset',
  'liability',
  'equity',
  'revenue',
  'expense',
]);
export type AccountType = z.infer<typeof AccountTypeSchema>;

/** Asset/Expense have a debit normal balance; Liability/Equity/Revenue have credit. */
export function normalBalance(type: AccountType): 'debit' | 'credit' {
  return type === 'asset' || type === 'expense' ? 'debit' : 'credit';
}

export const AccountSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.string().min(1).max(32),
  name: z.string().min(1).max(200),
  accountType: AccountTypeSchema,
  accountSubtype: z.string().max(64).nullable(),
  parentId: z.string().uuid().nullable(),
  currencyCode: z.string().length(3).regex(/^[A-Z]{3}$/),
  isActive: z.boolean(),
  description: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Account = z.infer<typeof AccountSchema>;

export const AccountCreateSchema = z.object({
  code: z.string().min(1).max(32),
  name: z.string().min(1).max(200),
  accountType: AccountTypeSchema,
  accountSubtype: z.string().max(64).optional(),
  parentId: z.string().uuid().optional(),
  currencyCode: z.string().length(3).regex(/^[A-Z]{3}$/),
  description: z.string().max(2000).optional(),
});

export type AccountCreate = z.infer<typeof AccountCreateSchema>;

export const AccountUpdateSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  accountSubtype: z.string().max(64).nullable().optional(),
  parentId: z.string().uuid().nullable().optional(),
  isActive: z.boolean().optional(),
  description: z.string().max(2000).nullable().optional(),
});

export type AccountUpdate = z.infer<typeof AccountUpdateSchema>;
